<template>
    <v-flex xs12 class="asset-summary">
        <v-card class="asset-data-table">
            <v-flex class="table-title-bar">
                <v-flex tag="small">{{displayGreeting()}} </v-flex>
            </v-flex>
            <v-flex class="asset-data-table-scroll asset-pending">
                <v-data-table
                    :headers="columns"
                    :items="pendingAssets"
                    item-key="id"
                    :expand="true"
                    no-data-text=''
                    :loading="true"
                    :hide-actions="!isAssetsExist"
                    :rows-per-page-items="[5,10,25]"
                    :pagination.sync="pagination">
                    <template slot="headers" slot-scope="props">
                        <tr>
                            <th class="checkbox-header"></th>
                            <th
                                v-for="header in props.headers"
                                :class="[header.sortable ?'column sortable white--text' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                @click="changeSort(header)"
                                :data-qe-id="`column_${header.value}`"
                                :key="header.text">
                                {{ header.text }}
                                <v-icon v-if="header.sortable" small color="white">arrow_upward</v-icon>
                            </th>
                        </tr>
                    </template>
                    <template slot="progress">
                        <status-overlay :action="loadGetPendingAssetsAction" contentHeight="100px">
                        </status-overlay>
                    </template>
                    <template slot="items" slot-scope="props">
                        <td @click="checkExpanded(props)" v-if="isAssetsExist" class="checkbox-header"> 
                            <i v-if="!(props.expanded && props.item.expanded)" 
                                :data-qe-id="`expandRowBtn_${props.item.id}`"
                                class="fa fa-plus-square fa-lg" 
                                aria-hidden="true"></i>
                            <i v-if="props.expanded && props.item.expanded" 
                                :data-qe-id="`collapseRowBtn_${props.item.id}`"
                                class="fa fa-minus-square fa-lg" 
                                aria-hidden="true"></i>
                        </td>
                        <td><span :title="props.item.name">{{ props.item.name }}</span></td>
                        <td><span :title="props.item.address1">{{ props.item.address1 }}</span></td>
                        <td><span :title="props.item.city">{{ props.item.city }}</span></td>
                        <td><span :title="props.item.country">{{ props.item.country }}</span></td>
                        <td><span :title="props.item.region">{{ props.item.region }}</span></td>
                    </template>
                    <template slot="expand" slot-scope="props">
                        <asset-summary-edit 
                            :formData="props" 
                            :memberId="memberId" 
                            v-if="props.expanded"
                            :viewFromNetwork="true"
                            @alert="showAlert"
                            @close="closeOrCollapseForm(props)">
                        </asset-summary-edit>
                    </template>
                    <template slot="no-data"> 
                        <v-flex pa-5 xs12 text-xs-center class="no-data">{{pendingAssetsConstants.NO_PENDING_ASSETS}}</v-flex>
                    </template>
                </v-data-table>
            </v-flex>
        </v-card>
        <confirmation-dialog
            v-model="showAssetDenySuccessDialog"
            typeOfDialog="alert"
            :yesFunction="hideSuccessDialog"
            :title="assetSummaryConstants.ASSET_DENY_SUCESS_TITLE"
            :closeFunction="hideSuccessDialog"
            :message="assetSummaryConstants.ASSET_DENY_SUCESS_TEXT"
            :yesText="assetSummaryConstants.OK">
        </confirmation-dialog>
        <confirmation-dialog
            v-model="showAssetApproveSuccessDialog"
            typeOfDialog="alert"
            :yesFunction="hideSuccessDialog"
            :title="assetSummaryConstants.ASSET_APPROVE_SUCCESS_TITLE"
            :closeFunction="hideSuccessDialog"
            :message="assetSummaryConstants.ASSET_APPROVE_SUCCESS_TEXT"
            :yesText="assetSummaryConstants.OK">
        </confirmation-dialog>
    </v-flex>
</template>
<script>
    import { assetSummaryConstants, pendingAssetsConstants } from '../MemberProfile/memberProfile.constants';
    import { mapGetters, mapActions, mapState } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeAction } from "../../store/storeActions.constant";
    import StatusOverlay from '@/components/StatusOverlay/StatusOverlay';
    import AssetSummaryEdit from '../MemberProfile/EditDialogues/AssetSummaryEdit';
    import ConfirmationDialog from '../MemberProfile/EditDialogues/ConfirmationDialog';

    export default {
        name: 'AssetPendingRequests',
        components: {
            AssetSummaryEdit,
            ConfirmationDialog,
            StatusOverlay,
        },
        data: () => ({
            assetSummaryConstants,
            columns: pendingAssetsConstants.COLUMN_HEADERS,
            pendingAssetsConstants,
            pagination: {
                sortBy: '',
            },
            showAssetDenySuccessDialog: false,
            showAssetApproveSuccessDialog: false,
        }),
        created() {
            this.getPendingAssets();
        },
        props: {
            memberId: {
                type: String,
                required: true,
            },
        },
        mounted() {
            window.smoothscroll = () => {
                const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
                if (currentScroll > 0) {
                    window.requestAnimationFrame(window.smoothscroll);
                    window.scrollTo(0, Math.floor(currentScroll - (currentScroll / 5)));
                }
            };
        },
        methods: {
            ...mapActions({
                getPendingAssets: `memberProfile/${storeAction.getPendingAssets}`,
            }),
            displayGreeting() {
                let message = 'Hi, ';
                if (this.profileInformation) {
                    message = `Hi ${this.profileInformation.firstName}, `;
                }
                if (this.pendingAssets.length === 0) {
                    message += this.pendingAssetsConstants.NO_PENDING_ASSETS;
                } else if (this.pendingAssets.length === 1) {
                    message += this.pendingAssetsConstants.ONE_PENDING_ASSET;
                } else {
                    message += `There are ${this.pendingAssets.length} businesses pending for approval.`;
                }
                return message;
            },
            checkExpanded(data) {
                data.expanded = !data.expanded;
                data.item.expanded = data.expanded;
            },
            changeSort(header) {
                if (header.sortable) {
                    const column = header.value;
                    if (this.pagination.sortBy === column) {
                        this.pagination.descending = !this.pagination.descending;
                    } else {
                        this.pagination.sortBy = column;
                        this.pagination.descending = false;
                    }
                }
            },
            closeOrCollapseForm(props) {
                this.checkExpanded(props);
                this.getPendingAssets();
                window.smoothscroll();
            },
            hideSuccessDialog() {
                this.showAssetDenySuccessDialog = false;
                this.showAssetApproveSuccessDialog = false;
                this.pendingAssets.forEach((x) => {
                    x.expanded = false;
                });
                this.getPendingAssets();
                window.smoothscroll();
            },
            showAlert(value) {
                if (value === 'showAssetDenySuccessDialog') {
                    this.showAssetDenySuccessDialog = true; 
                } else {
                    this.showAssetApproveSuccessDialog = true;
                }
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                profileInformation: `myAccount/${storeGetters.profileInformation}`,
                pendingAssets: `memberProfile/${storeGetters.pendingAssets}`,
            }),
            loadGetPendingAssetsAction() {
                return this.actions[storeAction.getPendingAssets];
            },
            isAssetsExist() {
                return this.pendingAssets.length > 0;
            },
        },
    };
</script>
<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";
    .asset-summary {
        .asset-data-table {
            border: 1px solid rgba($ypo-gray, 0.4);
            border-radius: 4px;
            background-color: $white;
            box-shadow: 0 1px 3px 0 rgba($black, 0.18);
            .table-title-bar {
                align-content: center;
                padding: 15px 10px 15px 10px;
                small {
                    line-height: 16px;
                    font-size: 14px;
                    color: $ypo-cta;
                }
            }   
            .asset-data-table-scroll {
                tr {
                    background: $ypo-dark-gray;
                    th {
                        color: $white;
                        font-weight: 600;
                        text-align: left;
                        white-space: normal;
                    }
                    td {
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                        color: $ypo-gray-text;
                    }                  
                }
                .checkbox-header {
                    width: 64px;
                    i {
                        color: $ypo-cta;
                        cursor: pointer;
                        font-size:16px;
                    }
                }
            }
        }
        .overlay {
            top: 120px;
            bottom: 50px;
        }
        @include breakpoint(xs) {
            .asset-data-table {
                margin-top: 20px;
            }
            .table-title-bar {
                small {
                    margin: 10px 10px 0 !important;
                }
            }
        }
        @include breakpoint(sm) {
            .asset-data-table {
                margin-top: 20px;
            }
        }
    }
</style>
<style lang="scss">
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";
.asset-data-table-scroll {
    .v-table__overflow {
        overflow: inherit;
        &::-webkit-scrollbar {
            width: 4px;
            height: 4px;
            background-color: $white;
        }
        &::-webkit-scrollbar-thumb {
            background: $ypo-cta;
            border-radius: 4px;
            height: 4px;
        }
    }
    .v-datatable {
        tbody {
            display:block;
            max-height: 490px;
            overflow-y:scroll;
            &::-webkit-scrollbar {
                width: 4px;
                height: 8px;
                background-color: $white;
            }
            &::-webkit-scrollbar-thumb {
                background: $ypo-cta;
                border-radius: 4px;
            }
            .no-data {
                font-size: 20px;
                color: $ypo-gray;
            }
        }
        thead, tbody tr {
            display:table;
            width:100%;
            table-layout:fixed; 
        }
        th {
            &.checkbox-header {
                .v-input--selection-controls__input {
                    i {
                        color: $white;
                    }
                }
            }
        }    
    }
    &.asset-pending {
        .v-datatable {
            tbody {
                overflow: inherit;
                max-height: inherit;
                .asset-edit {
                    margin: 0 10px;
                }
            }
        }
    }
    @include breakpoint(sm) {
        table.v-datatable {
            width: 1000px;
            max-width: 1000px;
        } 
        .v-table__overflow {
            overflow: auto;
        }         
    }
}
.bulk-add-info {
    p{
        padding: 10px;
    }
}
</style>
